<template>
  <div class="contact-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">Contact Us</span>
        <span class="page-subtitle">We're here to help</span>
      </div>
    </div>

    <div class="content-wrap">

      <!-- Hero banner -->
      <div class="contact-hero">
        <div class="hero-icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <div>
          <p class="hero-title">Send us a message</p>
          <p class="hero-sub">Our support team usually responds within 24 hours.</p>
        </div>
      </div>

      <!-- Contact form -->
      <div class="form-card">
        <form id="contact-form" v-on:submit.prevent="contact">

          <div class="field-group">
            <label class="field-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
              Your Message
            </label>
            <textarea
              id="message"
              class="field-textarea"
              v-model="message"
              rows="6"
              placeholder="Describe your issue or question…"
            ></textarea>
          </div>

          <!-- Error -->
          <transition name="fade">
            <div class="alert-box alert-box--error" v-if="errorMsg">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {{ errorMsg }}
            </div>
          </transition>

          <!-- Success -->
          <transition name="fade">
            <div class="alert-box alert-box--success" v-if="successMsg">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              {{ successMsg }}
            </div>
          </transition>

          <button type="submit" class="submit-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
            </svg>
            Send Message
          </button>

        </form>
      </div>

      <!-- Alternative contact -->
      <div class="alt-contact-card">
        <p class="alt-contact-label">Other ways to reach us</p>
        <a href="mailto:support@medicater.co.za" class="alt-contact-row">
          <div class="alt-icon-wrap alt-icon-wrap--email">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </div>
          <div class="alt-contact-info">
            <span class="alt-contact-type">Email</span>
            <span class="alt-contact-value">support@medicater.co.za</span>
          </div>
          <svg class="alt-chevron" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </a>
        <div class="alt-divider"></div>
        <a href="https://medicater.co.za" target="_blank" class="alt-contact-row">
          <div class="alt-icon-wrap alt-icon-wrap--web">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
          </div>
          <div class="alt-contact-info">
            <span class="alt-contact-type">Website</span>
            <span class="alt-contact-value">medicater.co.za</span>
          </div>
          <svg class="alt-chevron" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import Client from 'clientjs'

export default {
  name: 'contact',
  data: function () {
    return {
      message: '',
      successMsg: '',
      errorMsg: ''
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
  },
  methods: {
    logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    },
    contact: function () {
      this.errorMsg = ''
      this.successMsg = ''
      $.showLoading()

      var user = JSON.parse(window.localStorage.getItem('user'))
      var client = new Client()
      var that = this

      var data = {
        token: localStorage.getItem('token'),
        body: client.getUA(),
        subject: user.username + ': ' + this.message
      }

      $.ajax({
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        },
        url: 'https://admin.medicater.co.za/api/basic/support',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          $.hideLoading()
          if (data.success === false) {
            that.errorMsg = data.message
          } else {
            that.successMsg = 'Your message has been sent. We\'ll get back to you shortly.'
            that.message = ''
          }
        },
        error: function () {
          $.hideLoading()
          if (!navigator.onLine) {
            that.errorMsg = 'You\'re offline. Your message will be sent once you reconnect.'
            var queue = window.localStorage.getItem('queue') ? JSON.parse(window.localStorage.getItem('queue')) : []
            queue.push({ url: this.url, data: data, method: 'post' })
            window.localStorage.setItem('queue', JSON.stringify(queue))
          } else {
            that.errorMsg = 'Something went wrong. Please try again later.'
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255, 255, 255, 0.25); }

.header-info { display: flex; flex-direction: column; gap: 3px; }

.page-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
}

.page-subtitle {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
}

/* ── Content wrap ── */
.content-wrap {
  padding: 110px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 600px;
  margin: 0 auto;
}

/* ── Hero banner ── */
.contact-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  border-radius: 14px;
  padding: 20px;
}

.hero-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.hero-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 4px;
}

.hero-sub {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.4;
}

/* ── Form card ── */
.form-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid #e8edf2;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.field-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 6px;
}

.field-textarea {
  width: 100%;
  padding: 13px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  color: #0f172a;
  background: #f8fafc;
  resize: vertical;
  outline: none;
  box-sizing: border-box;
  font-family: inherit;
  line-height: 1.55;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}
.field-textarea:focus {
  border-color: #1a587b;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(26, 88, 123, 0.12);
}
.field-textarea::placeholder { color: #b0bcc8; }

/* Alerts */
.alert-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 14px;
}

.alert-box--error {
  background: #fff5f5;
  border: 1px solid #fed7d7;
  color: #c53030;
}

.alert-box--success {
  background: #f0fff4;
  border: 1px solid #c6f6d5;
  color: #276749;
}

.alert-box svg { flex-shrink: 0; margin-top: 1px; }

/* Submit button */
.submit-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 14px rgba(26, 88, 123, 0.3);
  transition: opacity 0.2s, transform 0.1s;
  letter-spacing: 0.3px;
}
.submit-btn:hover { opacity: 0.92; }
.submit-btn:active { transform: scale(0.98); }

/* ── Alt contact card ── */
.alt-contact-card {
  background: #fff;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid #e8edf2;
}

.alt-contact-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #94a3b8;
  margin: 0 0 14px;
}

.alt-contact-row {
  display: flex;
  align-items: center;
  gap: 14px;
  text-decoration: none !important;
  padding: 4px 0;
  transition: opacity 0.15s;
}
.alt-contact-row:hover { opacity: 0.75; }

.alt-icon-wrap {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.alt-icon-wrap--email {
  background: #e0f2fe;
  color: #0369a1;
}

.alt-icon-wrap--web {
  background: #ede9fe;
  color: #6d28d9;
}

.alt-contact-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.alt-contact-type {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #94a3b8;
}

.alt-contact-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.alt-chevron { color: #cbd5e1; flex-shrink: 0; }

.alt-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 12px 0;
}

/* Fade transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
